<div>
  <!-- MULTI STEPPER -->
  <mat-horizontal-stepper hide-header #stepper [linear]="false" class="w-100 h-100 bg-transparent">
    <!-- COMPOSITE/PHOTOGRAPHY FILES -->
    <mat-step [completed]="IsCompleteCompositePhotographyForm" class="h-100 w-100 m-0 p-0" state="data">
      <div class="step-container w-100 mx-auto">
        <mat-card class="card-general" *ngIf="!isCompositeActive">
          <mat-card-title>Fotograf&iacute;as</mat-card-title>
          <mat-card-content>
            <!-- PHOTOGRAPHY FORM -->
            <form [formGroup]="photographyForm">
              <div class="filetype-image-grid-container">
                <div *ngFor="let item of fileImageArray; index as i" class="w-100 h-100">
                  <div class="h-100 d-flex justify-content-center align-items-center" *ngIf="!isCompositeActive && i==4">
                    <p class="composite-text">
                      Si ya tienes tu composite generado da <a (click)="isCompositeActive = !isCompositeActive">click aqui</a> para subirlo.
                    </p>
                  </div>
                  <app-drag-and-drop *ngIf="i!=4" fileTitle="Fotografía {{item.label}}" [parentForm]="photographyForm" [nameControl]="item.name" [text]="'Inserta tu imagen aquí'" [accept]="'image/*'" [isRequired]="item.isRequired" (onSelectFile)="fileSelected($event, item, 'imageComposite')" (onDeleteFile)="deleteFile(item, 'imageComposite')" [fileSelected]="item.fileInfo">
                  </app-drag-and-drop>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
        <mat-card class="card-general" *ngIf="isCompositeActive">
          <mat-card-title>Composite</mat-card-title>
          <mat-card-content>
            <!-- COMPOSITE FORM -->
            <form [formGroup]="compositeForm">
              <div class="filetype-image-composite-container">
                <div *ngFor="let item of fileCompositeArray" class="w-100 h-100">
                  <app-drag-and-drop fileTitle="{{item.name}} Dental" [parentForm]="compositeForm" [nameControl]="item.name" [text]="'Inserta tu imagen aquí'" [isRequired]="true" [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'composite')"
                                     (onDeleteFile)="deleteFile(item, 'composite')" [fileSelected]="item.fileInfo">
                  </app-drag-and-drop>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
        <div class="row justify-content-center mx-auto w-50">
          <p class="composite-text" *ngIf="isCompositeActive">
            Si quieres subir cada imagen individualmente y crear tu composite da <a (click)="isCompositeActive = !isCompositeActive">click aqui</a>
          </p>
        </div>
      </div>
      <div *ngIf="isCaseDetail" class="d-flex justify-content-center">
        <button mat-button matStepperNext class="button secondary-button" [disabled]="!photographyForm.valid && !compositeForm.valid" (click)="updateSetupCurrentStep()">Radiografías / STL <mat-icon>chevron_right</mat-icon></button>
      </div>
    </mat-step>

    <!-- RADIOGRAPHY/STL FILES -->
    <mat-step  [stepControl]="stlForm" class="h-100 w-100 m-0 p-0" state="data">
      <div class="text-center step-container">
        <mat-card class="card-general">
          <mat-card-title>Radiograf&iacute;as</mat-card-title>
          <mat-card-content>
            <!-- Radiography Form -->
            <form [formGroup]="radiographyForm">
              <div class="filetype-grid-container">
                <div *ngFor="let item of fileRadiographyArray" class="w-100 h-100">
                  <app-drag-and-drop fileTitle="{{item.label}}" [parentForm]="radiographyForm" [nameControl]="item.name" [text]="'Inserta tu imagen aquí'" [accept]="'image/*'" (onSelectFile)="fileSelected($event, item, 'radiography')"
                                     (onDeleteFile)="deleteFile(item, 'radiography')" [fileSelected]="item.fileInfo">
                  </app-drag-and-drop>
                </div>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
        <mat-card class="card-general" *ngIf="fileSTLArray">
          <mat-card-title>Archivos STL</mat-card-title>
          <mat-card-content class="d-flex flex-column" *ngIf="(!hasARequestSmartSTL || (hasARequestSmartSTL && requestSmartSTLStatus == SmartSTLRequestStatuses.get('Smart STL disponible'))) ; else HasARequestSmartSTLLabel">

            <div class="btn btn-info p-2 my-2 text-white rounded-pill me-auto" *ngIf="hasARequestSmartSTL && requestSmartSTLStatus == SmartSTLRequestStatuses.get('Smart STL disponible')">
              Origen Inferior y Superior: Smart STL – {{requestSmartSTLPatientProfileId || 'No disponible' }}
            </div>

            <mat-button-toggle-group  class="rounded-pill me-auto bg-white p-1 mb-3" *ngIf="hasDentalMonitoringExternalDoctorinfo() && isCaseDetail && hasArcadOrderInPreviousCaseStage" (change)="refreshFEDMSSTL()" [(ngModel)]="stlFilesUploadType">
              <mat-button-toggle [value]="true" class="rounded-pill border-0">Carga manual</mat-button-toggle>
              <mat-button-toggle [value]="false" class="rounded-pill border-0" [disabled]="hasARequestSmartSTL || hasASTLFile()">Solicitar Smart STL</mat-button-toggle>
            </mat-button-toggle-group>

            <ng-container *ngIf="stlFilesUploadType;else RequestSmartSTL">
               <!-- STL Form -->
              <form [formGroup]="stlForm">
                <div class="filetype-grid-container">
                  <div *ngFor="let item of fileSTLArray" class="w-100 h-100">
                    <ng-container *ngIf="item.name == 'BiteSTL'">
                      <app-drag-and-drop [stlZipOnly]="true" fileTitle="{{item.label}}" [parentForm]="stlForm" [nameControl]="item.name" [text]="'Sube tu archivo .ZIP o .STL'" [isRequired]="false" isGenericFileType="true" [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item, 'stl')"
                                        (onDeleteFile)="deleteFile(item, 'stl')" [fileSelected]="item.fileInfo">
                      </app-drag-and-drop>
                    </ng-container>
                    <ng-container *ngIf="item.name != 'BiteSTL'">
                      <app-drag-and-drop [stlOnly]="true" fileTitle="{{item.label}}" [parentForm]="stlForm" [nameControl]="item.name" [text]="'Sube tu archivo .STL'" [isRequired]="true" isGenericFileType="true" [accept]="application/octet-stream" (onSelectFile)="fileSelected($event, item, 'stl')"
                                        (onDeleteFile)="deleteFile(item, 'stl')" [fileSelected]="item.fileInfo">
                      </app-drag-and-drop>
                    </ng-container>
                  </div>
                </div>
              </form>
            </ng-container>
            <ng-template #RequestSmartSTL>
              <div class="row" *ngIf="hasDentalMonitoringExternalDoctorinfo() && isCaseDetail && hasArcadOrderInPreviousCaseStage && !hasARequestSmartSTL && !hasASTLFile()">
                <div class="col-12 col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label>ID de Paciente</mat-label>
                    <input matInput type="text" [(ngModel)]="searchByPatientProfileId">
                    <button mat-button *ngIf="" matSuffix mat-icon-button aria-label="Clear">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6 d-flex align-items-center">
                  <button mat-button class="button btn-bg-primary me-auto" (click)="getDentalMonitoringPatientInfo()">Obtener resultados</button>
                </div>
                <div class="col-12 col-md-6 mt-3">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Nombre de Paciente</mat-label>
                    <input matInput type="text" [disabled]="true" [ngModel]="dentalMonitoringPatientInfo?.fullName" [required]="true"/>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6 mt-3">
                  <div class="row">
                    <div class="col-12 col-md-3 d-flex flex-column"><span class="my-auto">Confirma la fase actual *</span></div>
                    <div class="col-12 col-md-2">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label></mat-label>
                        <input matInput type="number" min="1" [max]="dentalMonitoringPatientInfo?.totalStage" [disabled]="disabledDentalMonitoringPatientPhaseInput" [(ngModel)]="dentalMonitoringPatientPhase" class="remove-number-spinners" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-md-1 d-flex">
                      <mat-divider [vertical]="true" class="mx-auto" style="height: 5cap !important;
                      width: 1px !important;
                      transform: rotate(24deg) !important;
                      border: 1px solid !important;"></mat-divider>
                    </div>
                    <div class="col-12 col-md-2">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label></mat-label>
                        <input matInput [disabled]="true" [required]="true" [ngModel]="dentalMonitoringPatientInfo?.totalStage"/>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 mt-3">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Instrucciones (opcional)</mat-label>
                    <textarea class="w-100" matInput [maxLength]="500" [(ngModel)]="dentalMonitoringInstructions" placeholder="Instrucciones (opcional)" name="" id="" rows="8"></textarea>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-6 mt-3">
                  <div class="row">
                    <div class="col-12 col-md-3 d-flex flex-column mt-2">Accesorios y botones *</div>
                    <div class="col-12 col-md-6">
                      <mat-radio-group class="d-flex flex-column" [(ngModel)]="dentalMonitoringAccessoriesAndButtons" [required]="true">
                        <mat-radio-button *ngFor="let ab of smartSTLAccessoriesAndButtons" [value]="ab.value" class="mt-2">
                          {{ ab.key }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
                <div class="col-12 d-flex flex-column pt-4">
                  <!--Boton de enviar solicitud-->
                  <button mat-button class="button secondary-button mx-auto" [disabled]="!validRequestSmartSTLForm() || sendingDentalMonitoringSmartStlRequest" (click)="sendDentalMonitoringSmartStlRequest()">Enviar solicitud</button>
                </div>
              </div>
            </ng-template>           
          </mat-card-content>
          <ng-template #HasARequestSmartSTLLabel>
            <mat-card-content class="text-start" *ngIf="hasARequestSmartSTL">
              <div *ngIf="requestSmartSTLStatus == SmartSTLRequestStatuses.get('Revisión')">
                STL en proceso, no se permite la cancelación
              </div>
              <ng-container *ngIf="(requestSmartSTLStatus != SmartSTLRequestStatuses.get('Smart STL disponible') 
              && requestSmartSTLStatus != SmartSTLRequestStatuses.get('Revisión')
              && requestSmartSTLStatus != SmartSTLRequestStatuses.get('En proceso de cancelación')); else HasARequestInCancelationProccess">
                <p>La solicitud de SmartSTL ha sido enviada.</p>
              </ng-container>
              <ng-template #HasARequestInCancelationProccess>
                <ng-container *ngIf="requestSmartSTLStatus == SmartSTLRequestStatuses.get('En proceso de cancelación')">
                  <p>Cancelación en proceso.</p>
                </ng-container>
              </ng-template>
              <div class="row w-50 gx-4 justify-content-center mx-auto">
                <button mat-button class="button bg-danger danger-button-action text-white mt-3 m-0 col-6" (click)="cancelDentalMonitoringSmartStlRequest()" [disabled]="disableCancelButton()">Cancelar solicitud</button>
              </div>      
            </mat-card-content>
          </ng-template>
          
          
        </mat-card>
        <ng-container *ngIf="!isCaseDetail">
          <app-client-case-additional-files></app-client-case-additional-files>
        </ng-container>
      </div>
      <div *ngIf="isCaseDetail" class="w-100 d-flex justify-content-center ">
        <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Composite / Fotografías</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
